"use client";

import { useId, useState } from "react";
import posthog from "posthog-js";
import { ChevronDown, SlidersHorizontal } from "lucide-react";

// Collapsible container that holds the activity-editor panels behind an
// "Edit my file" disclosure so they aren't all visible by default. The header
// and the editor cards share one panel: when open, the cards render stacked
// inside it, below a divider.
export function EditTools({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const contentId = useId();

  return (
    <div
      className={`rounded-xl glass-panel border transition-colors ${
        open ? "border-primary/20" : "border-primary/10 hover:border-primary/30"
      }`}
    >
      <button
        type="button"
        onClick={() =>
          setOpen((o) => {
            const next = !o;
            if (next) posthog.capture("edit_tools_opened");
            return next;
          })
        }
        aria-expanded={open}
        aria-controls={contentId}
        className="w-full p-6 flex items-center gap-4 text-left"
      >
        <div className="p-2.5 bg-primary/10 rounded-lg shrink-0">
          <SlidersHorizontal className="size-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold">Edit my file</p>
          <p className="text-sm text-muted-foreground">
            Change sport or device, trim, remove fields, adjust the time, and fix heart rate glitches.
          </p>
        </div>
        <ChevronDown
          className={`size-5 text-muted-foreground shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div
          id={contentId}
          className="flex flex-col gap-4 border-t border-border/60 p-4 sm:p-6"
        >
          {children}
        </div>
      )}
    </div>
  );
}
